import { gql } from '@apollo/client';

export const GET_LIST_AD_SET = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetAdSetList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on AdSets {
        data {
          id
          campaign_id
          campaign {
            id
            name
            budget
            budget_remaining
          }
          team_id
          name
          start_date
          end_date
          budget
          budget_remaining
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;
export const GET_LIST_AD_SET_DASHBOARD = gql`
  query GetList(
    $where: Map
    $sort: Map
    $ad_where: Map
    $offset: Int
    $limit: Int
  ) {
    GetAdSetList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on AdSets {
        data {
          id
          name
          start_date
          end_date
          ads(pagination: { where: $ad_where }) {
            ... on PaginationResponse {
              count
            }
          }
          created_at
          updated_at
          deleted_at
          team_id
        }
      }
    }
  }
`;

export const GET_AD_SET_ID = gql`
  query GetByID($id: String!) {
    list: GetAdSetByID(id: $id) {
      id
      campaign_id
      campaign {
        id
        name
        budget
        budget_remaining
        start_date
        end_date
      }
      team_id
      name
      start_date
      end_date
      budget
      budget_remaining
      created_at
      updated_at
      deleted_at
    }
  }
`;
